import { render, staticRenderFns } from "./Contact-Page.vue?vue&type=template&id=6b33f13f&"
import script from "./Contact-Page.vue?vue&type=script&lang=js&"
export * from "./Contact-Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports